import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import cmsSettingsService from "./cmsSettingsService";

export const getSettings = createAsyncThunk(
  "cmsSettings/get-settings",
  async (thunkAPI) => {
    try {
      return await cmsSettingsService.getSettings();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateSettings = createAsyncThunk(
  "cmsSettings/update-settings",
  async (settingsData, thunkAPI) => {
    try {
      return await cmsSettingsService.updateSettings(settingsData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadLogo = createAsyncThunk(
  "cmsSettings/upload-logo",
  async (formData, thunkAPI) => {
    try {
      return await cmsSettingsService.uploadLogo(formData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadFavicon = createAsyncThunk(
  "cmsSettings/upload-favicon",
  async (formData, thunkAPI) => {
    try {
      return await cmsSettingsService.uploadFavicon(formData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  settings: null,
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const cmsSettingsSlice = createSlice({
  name: "cmsSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.settings = action.payload;
        state.updatedSettings = action.payload;
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(uploadLogo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadLogo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        if (state.settings) {
          state.settings.logo = action.payload.logo;
        }
      })
      .addCase(uploadLogo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(uploadFavicon.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadFavicon.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        if (state.settings) {
          state.settings.favicon = action.payload.favicon;
        }
      })
      .addCase(uploadFavicon.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default cmsSettingsSlice.reducer;

